var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "topcoat:cancel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00212 10.1288L11.9476 14.1684C12.3434 14.5768 12.601 14.581 13.004 14.1684L13.7956 13.3577C14.1834 12.9608 14.2097 12.7002 13.7956 12.2762L9.6185 8L13.796 3.72381C14.1873 3.32191 14.1949 3.05067 13.796 2.64191L13.0044 1.83162C12.5937 1.41105 12.34 1.43048 11.948 1.83162L8.00212 5.87124L4.05659 1.832C3.66459 1.43086 3.41088 1.41143 3.00021 1.832L2.20859 2.64229C1.80935 3.05105 1.81659 3.32229 2.20859 3.72419L6.38574 8L2.20859 12.2762C1.7945 12.7002 1.81659 12.9608 2.20859 13.3577L2.99983 14.1684C3.39945 14.581 3.65697 14.5768 4.05621 14.1684L8.00212 10.1288Z",
    fill: "#17142E",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.61d024f436079243797b7181122389ef.svg";
export { ForwardRef as ReactComponent };